import React from "react";
import { Box, Stack, Typography } from "@mui/material";

const SKELETON_LINE1_PCT = [71, 58, 83, 64, 76, 52, 69, 61];
const SKELETON_LINE2_PCT = [44, 62, 37, 55, 48, 66, 41, 53];
const SKELETON_LINE3_PCT = [31, 27, 34, 22, 29, 25, 33, 28];

const PageListEmptyState = ({ message, minHeight = 260 }) => (
  <Box
    sx={{
      position: "relative",
      minHeight,
      borderRadius: 2,
      overflow: "hidden",
      backgroundColor: "#f5f5f5",
      border: "none",
    }}
  >
    <Stack
      spacing={1.5}
      sx={{
        filter: "blur(4px)",
        opacity: 0.55,
        p: 2,
        boxSizing: "border-box",
      }}
    >
      {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
        <Box
          key={i}
          sx={{
            height: 94,
            borderRadius: "12px",
            bgcolor: "#f5f5f5",
            border: "1px solid rgba(148, 163, 184, 0.35)",
            display: "flex",
            gap: 1.5,
            p: 1.5,
            alignItems: "center",
          }}
        >
          <Box sx={{ width: 64, height: 64, borderRadius: "10px", bgcolor: "#cbd5e1", flexShrink: 0 }} />
          <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 1, py: 0.25 }}>
            <Box
              sx={{
                height: 11,
                borderRadius: 1,
                bgcolor: "#94a3b8",
                width: `${SKELETON_LINE1_PCT[i % SKELETON_LINE1_PCT.length]}%`,
                maxWidth: "100%",
              }}
            />
            <Box
              sx={{
                height: 9,
                borderRadius: 1,
                bgcolor: "#cbd5e1",
                width: `${SKELETON_LINE2_PCT[i % SKELETON_LINE2_PCT.length]}%`,
                maxWidth: "100%",
              }}
            />
            <Box
              sx={{
                height: 8,
                borderRadius: 1,
                bgcolor: "#e2e8f0",
                width: `${SKELETON_LINE3_PCT[i % SKELETON_LINE3_PCT.length]}%`,
                maxWidth: "100%",
                display: { xs: "none", sm: "block" },
              }}
            />
          </Box>
        </Box>
      ))}
    </Stack>
    <Box
      sx={{
        mt: 17,
        position: "absolute",
        inset: 0,
        display: "block",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        px: 2,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Rubik",
          fontWeight: 600,
          fontSize: { xs: 14, sm: 15 },
          color: "#0f172a",
          textAlign: "center",
          lineHeight: 1.45,
          textShadow: "0 0 12px rgba(255,255,255,0.95), 0 0 20px rgba(255,255,255,0.8)",
        }}
      >
        {message}
      </Typography>
    </Box>
  </Box>
);

export default PageListEmptyState;
